export const DEFAULT_NAME_FALLBACK = "Unknown"

export const joinNonEmpty = (parts: (string | null | undefined)[], separator = " ", fallback = ""): string =>
  parts.filter((part): part is string => Boolean(part?.trim())).join(separator) || fallback

export const formatFullName = (firstName?: string | null, lastName?: string | null): string =>
  joinNonEmpty([firstName, lastName], " ", DEFAULT_NAME_FALLBACK)

export const formatProductLabel = (product: {
  companyProductDescription?: string | null
  publicId?: string | null
}): string => joinNonEmpty([product.companyProductDescription, product.publicId], " - ")

export const formatRequestIdSuffix = (requestIds: string[]): string => {
  if (requestIds.length === 0) return ""
  if (requestIds.length === 1) return `Request ID: R-${requestIds[0]}`
  return `Request IDs: ${requestIds.map((id) => `R-${id}`).join(", ")}`
}
